import React, { useMemo, useState } from 'react';
import './Grid.scss';
import { DataCollectionFieldModel } from '../../pages/Assessment/types';
import { fieldsConfig } from '../common/TabContent';
import { SelectInput } from '../Form/Select';
import { useDispatch, useSelector } from 'react-redux';
import {
  addGridRowAction,
  removeGridRowAction,
} from '../../store/assessmentSingle/actions';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '../../../src/assets/icons/ic-info.svg';
import { translateTabContentText } from 'utils/helpers/useTranslation';
import { CONDITIONS } from 'utils/helpers/enum';
import { checkAllConditionsFollow } from 'utils/helpers/useCondition';

interface IProps {
  allFields: any;
  newData?: any;
  data: DataCollectionFieldModel;
  pageNum: number;
  assId: number;
  translations: any;
}

export const Grid = ({
  newData,
  allFields,
  data,
  pageNum,
  assId,
  translations,
}: IProps) => {
  const dispatch = useDispatch();
  const [lengthFields, setLengthFields] = useState(true);
  const [minLengthFields, setMinLengthFields] = useState(false);
  const onAddRowClick = () => {
    dispatch(
      addGridRowAction({ assId, pageNum, gridName: data.Template.Name }),
    );
  };

  const onRemoveRowClick = () => {
    dispatch(
      removeGridRowAction({ assId, pageNum, gridName: data.Template.Name }),
    );
  };

  useMemo(() => {
    data.GridChildren.length < 1
      ? setLengthFields(false)
      : setLengthFields(true);
    data.GridChildren[0]?.length > 4
      ? setMinLengthFields(true)
      : setMinLengthFields(false);
  }, []);

  return (
    <div className="grid-wrapper">
      <div className="grid-heading">
        <p className="grid-title">
          {translateTabContentText(data?.Template?.DisplayName, translations)}
        </p>
        {data.Template.Validator.MaxRows !==
          data.Template.Validator.MinRows && (
          <>
            <button
              type="button"
              onClick={onAddRowClick}
              disabled={
                data.GridChildren.length >= data.Template.Validator.MaxRows
              }
            >
              +
            </button>
            <button
              type="button"
              onClick={onRemoveRowClick}
              disabled={
                data.GridChildren.length <= data.Template.Validator.MinRows
              }
            >
              -
            </button>
          </>
        )}
        {data.Template.HelpText && (
          <div className="heading-tooltip">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${data.Template.DisplayName}`}>
                  {translateTabContentText(
                    data.Template.HelpText,
                    translations,
                  )}
                </Tooltip>
              }
            >
              <img
                src={InfoIcon}
                alt="info img"
                className="tooltip-trigger"
                data-toggle="tooltip"
              />
            </OverlayTrigger>
          </div>
        )}
      </div>
      <hr />
      <div
        className="grid-fields scroll"
        style={{
          overflowX: minLengthFields ? 'scroll' : 'unset',
          width: 1186,
          padding: '10px 0',
          whiteSpace: minLengthFields ? 'nowrap' : 'unset',
          verticalAlign: 'top',
          position: 'relative',
          visibility: lengthFields ? 'unset' : 'hidden',
          marginBottom: ' 10px',
        }}
      >
        <>
          <table>
            <div className="fields-row">
              <tr>
                {data.GridChildren[0]?.map(f => (
                  <th
                    style={{
                      width: 236,
                      textAlign: 'center',
                      color: 'black',
                      paddingBottom: 5,
                    }}
                  >
                    {translateTabContentText(
                      f.Template.DisplayName,
                      translations,
                    )}
                  </th>
                ))}
              </tr>
            </div>

            <>
              {data.GridChildren &&
                data.GridChildren.map((fieldsArray, index) => {
                  return (
                    <div className="fields-row " key={`${data.Guid}${index}`}>
                      <tr
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {fieldsArray.map(f => {
                          const visible = f.Template.InitiallyVisibleOnLoad;
                          const noDisplayConditions =
                            f.Template.DisplayConditions.length < 1 ||
                            f.Template.DisplayConditions === undefined ||
                            f.Template.DisplayConditions === null;
                          const conditionToShow =
                            visible ||
                            (!visible && noDisplayConditions) ||
                            (!visible &&
                              !noDisplayConditions &&
                              checkAllConditionsFollow(f, newData));
                          if (fieldsConfig[f.Template.FieldType.Name]) {
                            let Component;
                            if (
                              f.Template.FieldType.Name === 'Text' &&
                              f.Template.Parameters.MultiLine
                            ) {
                              Component = fieldsConfig['Textarea'];
                            } else {
                              Component =
                                fieldsConfig[f.Template.FieldType.Name];
                            }
                            if (f.Template.FieldType.Name === 'Selection') {
                              return (
                                <td className={!conditionToShow ? 'hide' : ''}>
                                  <div
                                    className={!conditionToShow ? 'hide' : ''}
                                  >
                                    <SelectInput
                                      translations={translations}
                                      key={f.Guid}
                                      name={`${data.Guid}[${index}][${f.Template.Name}]`}
                                      imageFile={f.Template?.ImageFile}
                                      OriginalHeight={
                                        f.Template?.OriginalHeight
                                      }
                                      OriginalSize={f.Template?.OriginalSize}
                                      OriginalWidth={f.Template?.OriginalWidth}
                                      ImageHeight={f.Template?.ImageHeight}
                                      MaintainAspectRatio={
                                        f.Template?.MaintainAspectRatio
                                      }
                                      ImageWidth={f.Template?.ImageWidth}
                                      // to delete after testing
                                      // labelText={translateTabContentText(
                                      //   f.Template.DisplayName,
                                      //   translations,
                                      // )}
                                      options={f.Template.Parameters.ValuesList?.Values.map(
                                        o => ({
                                          value: o.ID,
                                          label: o.Name,
                                        }),
                                      )}
                                      disabled={false}
                                      required={f.Template.Required}
                                    />
                                  </div>
                                </td>
                              );
                            }
                            return (
                              <td>
                                <div className={!conditionToShow ? 'hide' : ''}>
                                  <div>
                                    <Component
                                      key={f.Guid}
                                      name={`${data.Guid}[${index}][${f.Template.Name}]`}
                                      // to delete after testing
                                      // labelText={translateTabContentText(
                                      //   f.Template.DisplayName,
                                      //   translations,
                                      // )}
                                      imageFile={f.Template?.ImageFile}
                                      OriginalHeight={
                                        f.Template?.OriginalHeight
                                      }
                                      OriginalSize={f.Template?.OriginalSize}
                                      OriginalWidth={f.Template?.OriginalWidth}
                                      ImageHeight={f.Template?.ImageHeight}
                                      ImageWidth={f.Template?.ImageWidth}
                                      MaintainAspectRatio={
                                        f.Template?.MaintainAspectRatio
                                      }
                                      toolTipText={translateTabContentText(
                                        f.Template.HelpText,
                                        translations,
                                      )}
                                      postfixText={
                                        f.Template?.Parameters?.MeasureDetail
                                          ?.PostfixText
                                      }
                                      disabled={false}
                                      required={f.Template.Required}
                                    />
                                  </div>
                                </div>
                              </td>
                            );
                          }
                        })}
                      </tr>
                    </div>
                  );
                })}
            </>
          </table>
        </>
      </div>
    </div>
  );
};
